export const enum API_STATUS {
  idle = 'idle',
  loading = 'loading',
  success = 'success',
  failed = 'failed'
}

export interface ERROR_TEMPLATE{
  status: number
  code: string
  message: string 
}